import type { SxProps, Theme } from "@mui/material";

export const editExistingActivityModalPaperSx: SxProps<Theme> = {
  width: "min(52rem, calc(100vw - 2rem))",
  maxHeight: "80vh",
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  mx: "auto",
  mt: 8,
  p: 2,
  display: "flex",
  flexDirection: "column",
  gap: 2,
};

export const editExistingActivityModalTableWrapSx: SxProps<Theme> = {
  overflow: "auto",
  border: "1px solid",
  borderColor: "divider",
  borderRadius: 1,
};

export const editExistingActivityModalInteractiveCellSx: SxProps<Theme> = {
  cursor: "pointer",
};
